import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { SiteCookies } from '@chefami-monorepo/types';

/**
 * headerInterceptor
 *
 * Modern functional interceptor that:
 * - Adds Authorization bearer token from cookies for protected endpoints
 * - Excludes auth headers for public endpoints (login, site data, token refresh)
 * - Simple and focused on the original migration functionality
 */
export const headerInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(StorageService);

  // Check if this endpoint requires authorization (same logic as original)
  const isPublicEndpoint =
    req.url.includes('login') ||
    req.url.includes('fetch-site-data') ||
    req.url.includes('get-new-token');

  // Add authorization header for protected endpoints only
  if (!isPublicEndpoint) {
    const accessToken = storage.getCookie(SiteCookies.ACCESS_TOKEN);
    if (accessToken) {
      const modifiedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      return next(modifiedReq);
    }
  }

  // For public endpoints or when no token, pass through unchanged
  return next(req);
};
